import { render, staticRenderFns } from "./hidden-file-input.vue?vue&type=template&id=50407369&scoped=true"
import script from "./hidden-file-input.vue?vue&type=script&lang=js"
export * from "./hidden-file-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50407369",
  null
  
)

export default component.exports